export default {
	errorList: [],
	dialog: {
		open: false,
		title: "",
		message: "",
		closeLabel: "",
	},
	update: {
		open: false
	}
};
